import { render, staticRenderFns } from "./PromotionRequestForm.vue?vue&type=template&id=17ca45ce&"
import script from "./PromotionRequestForm.vue?vue&type=script&lang=js&"
export * from "./PromotionRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports